import { useEffect } from "react";
import { ClientOverviewRepositoryImpl } from "../../data/repositories/ClientOverviewRepositoryImpl";
import { GetExpenseBootstrapUseCase } from "../../domain/use-cases/GetExpenseBootstrapUseCase";
import {
  getExpenseBootstrapData,
  getExpenseBootstrapError,
  getExpenseBootstrapPromise,
  setExpenseBootstrapData,
  setExpenseBootstrapError,
  setExpenseBootstrapPromise,
} from "../state/expenseBootstrapStore";

const repository = new ClientOverviewRepositoryImpl();
const useCase = new GetExpenseBootstrapUseCase(repository);

/**
 * Single fetch of Expense page bootstrap (deduped across hooks).
 */
export function useExpenseBootstrap(): void {
  useEffect(() => {
    if (getExpenseBootstrapData() || getExpenseBootstrapError()) {
      return;
    }

    if (!getExpenseBootstrapPromise()) {
      const promise = useCase.execute();
      setExpenseBootstrapPromise(promise);
      promise
        .then((entity) => {
          setExpenseBootstrapError(null);
          setExpenseBootstrapData(entity);
        })
        .catch((err) => {
          const message =
            err instanceof Error ? err.message : "Failed to load expense bootstrap";
          setExpenseBootstrapError(message);
        })
        .finally(() => {
          setExpenseBootstrapPromise(null);
        });
    }
  }, []);
}
